<template>
    <div>
        <HeaderTopComponent  v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10 '/>
        <BreadCrumbsComponent :breadcrumbs="breadcrumbs" class="margin-breadcrumb mt-180"/>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6" >
            <h1 class="font-size-custom font-weight-bold color-title-corporative font-title"><i>EMPRESAS Y PYMES</i></h1>
        </div>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6">
            <div v-if="$route.path == '/empresas_pymes'">
                <v-expansion-panels class="mb-6 col-md-6 px-0 border-card" elevation="0">
                    <v-expansion-panel style='border-radius: 20px; box-shadow: none'>
                        <v-expansion-panel-header expand-icon="mdi-menu-down" class="border-expand py-0 px-0 px-md-3">
                            <v-row
                                    align="center"
                                    justify="center"
                                    class='row-icon-expand'
                                >
                                <v-col cols=3 md=2 class="text-center border-panel">
                                        <v-img 
                                            :src="`${require('@/assets/corporativo.png')}`" 
                                            style="width:80px;margin:0 auto"    
                                        />
                                </v-col>
                                <v-col cols=9 md=10 class='pl-0 pl-md-5 text-center text-md-left  font-title'>
                                    <div class="text-body-1 text-sm-h5 text-md-h5 gray--text " style='line-height:1'><b>IMPORTACIONES</b></div>
                                    </v-col>
                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-col class="div-description-panel grayblack--text font-text">
                                Realizamos importaciones de <b>equipos médicos y medicinas</b> específicas para garantizar que en el mercado ecuatoriano estén disponibles
                                las medicinas y los equipos que se requieran.
                                <p class='mb-0 mt-2'>
                                    Para recibir asesoramiento pida su 
                                    <router-link class='blue--text' to='/empresas_pymes/cotizacion/importaciones'>
                                        cotización
                                    </router-link>
                                </p>
                            </v-col>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-expansion-panels class="mb-6 col-md-6 px-0 border-card" elevation="0">
                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-menu-down" class="border-expand py-0 px-0 px-md-3">
                        <v-row
                                align="center"
                                justify="center"
                                class='row-icon-expand'
                            >
                            <v-col  cols=3 md=2 class="text-center border-panel">
                                    <v-img 
                                        :src="`${require('@/assets/coporativo-representacion-marca.png')}`" 
                                        style="width:80px;margin:0 auto"  
                                    />
                            </v-col>
                            <v-col cols=9 md=10 class='pl-0 pl-md-5 text-center text-md-left  font-title'>
                                <div class="text-body-1 text-sm-h5 text-md-h5 gray--text " style='line-height:1'><b>REPRESENTACIÓN DE MARCA</b></div>
                                </v-col>
                        </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-col class="div-description-panel grayblack--text font-text">
                                Estamos abiertos a representar productos médicos dentro de nuestro mercado.<br />
                                Actualmente estamos en constante búsqueda de nuevos aliados para ampliar nuestro portafolio de soluciones.
                                <p class='mb-0 mt-2'>Para recibir asesoramiento pida su 
                                    <router-link class='blue--text' to='/empresas_pymes/cotizacion/representacion-marca'>
                                        cotización
                                    </router-link>
                                </p>    
                            </v-col>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <router-view @newBreadcrumbs=newBreadcrumbs></router-view>
        </div>
        <FooterComponent />
    </div>
</template>

<script>
import CardServiciosComponent from '../partials/CardServiciosComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'

export default {
    name:'CompaniesAndPymesComponent',
    components:{
        CardServiciosComponent,
        MenuMovilComponent,
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
    },
    data:() => ({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Empresas y Pymes',url:'/empresas_pymes'}
        ],
        dialog1:false,
        dialog2:false,
        dialog3:false,
        dialog4:false,
        dialog5:false,
        content1:`<div class="row align-center">
                    <div class="col-2 py-0 text-center rounded">
                        <img src="${require("@/assets/corporativo-atencion-primaria.png")}" class="img-dialog-description">
                    </div>
                    <div class="col-10 pt-0 pl-sm-0 pl-5 orange--text">
                        <h2 class="font-weight-black col font-title"><i>Insumos <br /> y equipos médicos</i></h2>
                    </div>
                </div>
                <p class="grayblack--text font-text">Para ayudarlo a garantizar la <b>seguridad ocupacional,</b> le proporcionamos el acceso a <b>insumos y equipos médicos</b> de primer nivel.</p>
                <p class="mb-0 mt-3 grayblack--text font-text">Para recibir asesoramiento pida su <a href="/empresas_pymes/cotizacion/insumos-equipos">cotización.</a></p>`,
        content2:`<div class="row align-center">
                    <div class="col-2 py-0 text-center rounded">
                        <img src="${require("@/assets/corporativo-atencion-primaria.png")}" class="img-dialog-description">
                    </div>
                    <div class="col-10 pt-0 pl-sm-0 pl-5 orange--text">
                        <h2 class="font-weight-black col font-title"><i>Exámenes pre y post ocupacionales</i></h2>
                    </div>
                </div>
                <p class="grayblack--text font-text">Realizamos exámenes pre y post ocupacionales para ayudarlo a garantizar la seguridad ocupacional dentro de su empresa.</p>
                <p class="grayblack--text font-text">En nuestros laboratorios contamos con altos estándares de calidad, otorgamos resultados precisos y confiables. Contamos con la tecnología actualizada, el equipamiento específico y la infraestructura necesaria para garantizar las reglas de bioseguridad.</p>
                <p class="mb-0 mt-3 grayblack--text font-text">Para recibir asesoramiento pida su cotización  <a href="/empresas_pymes/cotizacion/examen-pre-post-ocupacional">cotización.</a></p>`,
        content3:`<div class="row align-center">
                    <div class="col-2 py-0 text-center rounded">
                        <img src="${require("@/assets/coporativo-informe.png")}"  class="img-dialog-description">
                    </div>
                    <div class="col-10 pt-0 pl-sm-0 pl-5  orange--text">
                        <h2 class='font-weight-black col font-title'><i>Informe médico</i></h2>
                    </div>
                </div>
                <p class="grayblack--text">Realizamos exámenes pre - ocupacionales y otorgáramos el <b>apto médico</b> a aquellos que puedan incorporarse a su empresa. </p>
                <p class="grayblack--text">En nuestros laboratorios contamos con altos estándares de calidad, otorgamos resultados precisos y confiables. Contamos con la tecnología actualizada, el equipamiento específico y la infraestructura necesaria para garantizar las reglas de bioseguridad. </p>
                <p class="mb-0 mt-3 grayblack--text">Para recibir asesoramiento su <a href="/empresas_pymes/cotizacion/apto-medico">cotización.</a></p>`,
        content4:`<div class="row align-center">
                    <div class="col-2 py-0 text-center rounded">
                        <img src="${require("@/assets/coporativo-informe.png")}"  class="img-dialog-description">
                    </div>
                    <div class="col-10 pt-0 pl-sm-0 pl-5  orange--text">
                        <h2 class='font-weight-black col font-title'><i>Chequeos ocupacionales preventivos</i></h2>
                    </div>
                </div>
                <p class="grayblack--text">Hacemos chequeos ocupaciones con la finalidad de prevenir cualquier tipo de enfermedad futura en sus empleados.  </p>
                <p class="grayblack--text">En nuestros laboratorios contamos con altos estándares de calidad, otorgamos resultados precisos y confiables. Contamos con la tecnología actualizada, el equipamiento específico y la infraestructura necesaria para garantizar las reglas de bioseguridad.</p>
                <p class="mb-0 mt-3 grayblack--text">Para recibir asesoramiento pida su <a href="/empresas_pymes/cotizacion/chequeo-ocupacional-preventivo">Cotización</a></p>`,
        content5:`<div class="row align-center">
                    <div class="col-2 py-0 text-center rounded">
                        <img src="${require("@/assets/corporativo.png")}" class="img-dialog-description">
                    </div>
                    <div class="col-10 pt-0 pl-sm-0 pl-5  orange--text">
                        <h2 class='font-weight-black col font-title'><i>Medicina <br class='d-none d-sm-block'/>de atención primaria</i></h2>
                    </div>
                </div>
                <p class="grayblack--text">Nos encargamos de abastecer las clínicas y los hospitales de medicinas de necesidad básica</p>
                <p class="mb-0 mt-3 grayblack--text">Para recibir asesoramiento su <a href="/empresas_pymes/cotizacion/atencion-primaria ">cotización.</a></p>`
    }),
    computed:{

        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },

    },
    methods:{
        diag1(val){
            this.dialog1=val
        },
        diag2(val){
            this.dialog2=val
        },
        diag3(val){
            this.dialog3=val
        },
        diag4(val){
            this.dialog4=val
        },
        diag5(val){
            this.dialog5=val
        },
        newBreadcrumbs(newBreadcrumbs){
             this.$emit('newBreadcrumbs',newBreadcrumbs)
        }
    },
    created(){
        
         this.$emit('newBreadcrumbs',this.breadcrumbs)
    }
}
</script>

<style>
    .border-expand{
        border: 3px solid #26aeea;
        border-radius: 20px;
    }
    .border-card {
        border-top-left-radius: 20px!important;
        border-top-right-radius: 20px!important;
    }
    .border-panel{
        background: #26aeea;
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }
    .div-description-panel{
        margin-top:10px;
        border-left: 2px solid #ffaa45;
        color:#87847b
    
    }
    .v-expansion-panel:before {
        box-shadow: none;
    
    }
    .v-expansion-panel-header{
        -webkit-box-shadow: 5px 3px 16px -8px rgba(0,0,0,0.74);
        box-shadow: 5px 3px 16px -8px rgba(0,0,0,0.74);
    }

    .color-border-card-occupational-security{
        border: 3px solid #ffaa45!important;
        border-radius: 20px!important;
    }
    
    .img-dialog-description{
        max-width: 56px;
        background: #ffaa45;
        padding: 8px;
        border-radius: 10px;
    }

    .v-application .text-md-h3, .v-application .text-md-h5{
        font-family: Asap!important
    }

    @media (max-width:959px){
        .row-icon-expand{
            left: 12px;
            position: relative;
        }
        .border-panel{
            border-top-right-radius: 14px;
            border-bottom-right-radius: 14px;
        }
        .border-panel{
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
        }
    }

    @media (max-width: 1150px){
        .v-application .text-md-h5 {
            font-size: 1.2rem!important;
        }
    }

    @media (max-width:1122px) and (min-width:960px){
        .v-application .text-md-h7 {
            font-size: 0.89rem!important;
        }
    }
</style>
